<template>
    <div class="box" @click="editOffer($event)">
        <span class="title">
            <div class="type" id="v-step-stav">
                <span v-show="data.offer.koncept == 0 &&
                    data.offer.active == 0
                    " class="green vue_show_tooltip" data-click="no">
                    <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.row_active_tooltip')" />
                </span>
                <span v-show="data.offer.koncept != 0" class="orange vue_show_tooltip" data-click="no">
                    <tool-tip class="vue_tooltip hide" side="l" text="Ponuka je v stave konceptu" />
                </span>
                <span v-show="data.offer.koncept == 0 &&
                    data.offer.active == 1
                    " class="red vue_show_tooltip" data-click="no">
                    <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.row_inactive_tooltip')" />
                </span>
            </div>
            <div class="vue_show_tooltip">
                {{ setTitle(data.offer.nazov) }}
                <tool-tip v-show="data.offer.nazov.length >= 100" class="vue_tooltip hide" side="l"
                    :text="data.offer.nazov" />
            </div>
        </span>
        <!--top -->
        <div class="top">
            <div class="left_side">
                <div class="title_client">
                    <a class="client" v-if="data.offer.klient_id" data-click="no" @click="openKlient(data.offer.klient_id)">
                        {{ data.klient_nazov[0] }}
                    </a>
                    <a v-else href="#" class="client text-danger" data-click="no">
                        {{ $t('offer.row_no_client') }}
                    </a>
                    <a v-if="data.offer.user_provided_id" class="user_provided_id">
                        #{{ data.offer.user_provided_id }}
                    </a>
                    <div class="offer_firma_user">
                        <div v-if="data.offer.user_created != null" class="who_create_offer_cont">
                            <span class="who_create_offer vue_show_tooltip" data-click="no">
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_5884_6601)">
                                        <path
                                            d="M4 4C4.34612 4 4.68446 3.89737 4.97225 3.70507C5.26003 3.51278 5.48434 3.23947 5.61679 2.9197C5.74924 2.59993 5.7839 2.24806 5.71637 1.90859C5.64885 1.56913 5.48218 1.25731 5.23744 1.01256C4.9927 0.767822 4.68087 0.601151 4.34141 0.533627C4.00194 0.466102 3.65007 0.500758 3.3303 0.633212C3.01053 0.765665 2.73722 0.989967 2.54493 1.27775C2.35264 1.56554 2.25 1.90388 2.25 2.25C2.25046 2.71399 2.43499 3.15884 2.76307 3.48693C3.09116 3.81501 3.53601 3.99954 4 4ZM4 1.08333C4.23074 1.08333 4.45631 1.15176 4.64817 1.27995C4.84002 1.40815 4.98956 1.59036 5.07786 1.80354C5.16616 2.01672 5.18927 2.2513 5.14425 2.47761C5.09923 2.70392 4.98812 2.9118 4.82496 3.07496C4.6618 3.23812 4.45392 3.34923 4.22761 3.39425C4.00129 3.43927 3.76672 3.41616 3.55354 3.32786C3.34036 3.23956 3.15815 3.09002 3.02995 2.89817C2.90176 2.70631 2.83333 2.48075 2.83333 2.25C2.83333 1.94058 2.95625 1.64384 3.17504 1.42504C3.39383 1.20625 3.69058 1.08333 4 1.08333V1.08333Z"
                                            fill="#9CA3AF" />
                                        <path
                                            d="M4 4.58334C3.30404 4.58411 2.63681 4.86092 2.1447 5.35303C1.65258 5.84515 1.37577 6.51238 1.375 7.20834C1.375 7.28569 1.40573 7.35988 1.46043 7.41458C1.51513 7.46927 1.58931 7.5 1.66667 7.5C1.74402 7.5 1.81821 7.46927 1.87291 7.41458C1.9276 7.35988 1.95833 7.28569 1.95833 7.20834C1.95833 6.66685 2.17344 6.14755 2.55632 5.76466C2.93921 5.38177 3.45852 5.16667 4 5.16667C4.54148 5.16667 5.06079 5.38177 5.44368 5.76466C5.82656 6.14755 6.04167 6.66685 6.04167 7.20834C6.04167 7.28569 6.0724 7.35988 6.12709 7.41458C6.18179 7.46927 6.25598 7.5 6.33333 7.5C6.41069 7.5 6.48487 7.46927 6.53957 7.41458C6.59427 7.35988 6.625 7.28569 6.625 7.20834C6.62423 6.51238 6.34742 5.84515 5.8553 5.35303C5.36319 4.86092 4.69596 4.58411 4 4.58334V4.58334Z"
                                            fill="#9CA3AF" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_5884_6601">
                                            <rect width="7" height="7" fill="white" transform="translate(0.5 0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <tool-tip style="width: 260px; padding: 9px 9px" class="vue_tooltip hide" side="l"
                                    :text="'Ponuku vytvoril ' + getCreatedName" />
                            </span>
                            <span class="who_create_offer_text">{{
                                getCreatedName
                                }}</span>
                        </div>
                        <div class="who_create_offer_cont">
                            <span class="who_create_offer vue_show_tooltip" data-click="no">
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                    fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M1.60001 1.6C1.60001 1.38783 1.6843 1.18435 1.83433 1.03432C1.98436 0.884288 2.18784 0.800003 2.40001 0.800003H5.60001C5.81219 0.800003 6.01567 0.884288 6.1657 1.03432C6.31573 1.18435 6.40001 1.38783 6.40001 1.6V6.4C6.5061 6.4 6.60784 6.44215 6.68286 6.51716C6.75787 6.59217 6.80001 6.69392 6.80001 6.8C6.80001 6.90609 6.75787 7.00783 6.68286 7.08285C6.60784 7.15786 6.5061 7.2 6.40001 7.2H5.20001C5.09393 7.2 4.99218 7.15786 4.91717 7.08285C4.84216 7.00783 4.80001 6.90609 4.80001 6.8V6C4.80001 5.89392 4.75787 5.79217 4.68286 5.71716C4.60784 5.64215 4.5061 5.6 4.40001 5.6H3.60001C3.49393 5.6 3.39218 5.64215 3.31717 5.71716C3.24216 5.79217 3.20001 5.89392 3.20001 6V6.8C3.20001 6.90609 3.15787 7.00783 3.08285 7.08285C3.00784 7.15786 2.9061 7.2 2.80001 7.2H1.60001C1.49393 7.2 1.39218 7.15786 1.31717 7.08285C1.24215 7.00783 1.20001 6.90609 1.20001 6.8C1.20001 6.69392 1.24215 6.59217 1.31717 6.51716C1.39218 6.44215 1.49393 6.4 1.60001 6.4V1.6ZM2.80001 2H3.60001V2.8H2.80001V2ZM3.60001 3.6H2.80001V4.4H3.60001V3.6ZM4.40001 2H5.20001V2.8H4.40001V2ZM5.20001 3.6H4.40001V4.4H5.20001V3.6Z"
                                        fill="#9CA3AF" />
                                </svg>
                                <tool-tip style="width: 260px; padding: 9px 9px" class="vue_tooltip hide" side="l"
                                    :text="data.offer.mojafirma ? data.offer.mojafirma.nazov : data.offer.company.firma" />
                            </span>
                            <span class="who_create_offer_text">{{
                                data.offer.mojafirma ? data.offer.mojafirma.nazov : data.offer.company.firma
                                }}</span>
                        </div>
                    </div>
                </div>
                <div class="state_container">
                    <div class="state" :style="'background:' + current_state.color" @focusout="show_states = false"
                        @click="show_states = !show_states" data-click="no">
                        <div :class="'current_state state' + current_state.id" data-click="no">
                            <span data-click="no">{{
                                current_state.state
                                }}</span>
                            <svg :class="show_states ? 'rotate' : ''" width="8" height="5" viewBox="0 0 8 5" fill="none"
                                xmlns="http://www.w3.org/2000/svg" data-click="no">
                                <path d="M6.91667 0.75L4 3.66667L1.08334 0.75" stroke="white" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div v-if="show_states" class="other_states" data-click="no">
                            <div v-for="state in orderOfferState" :key="state.id" @click="updateState(state)" :class="state.id == current_state.id
                                ? 'one_state active'
                                : 'one_state'
                                " data-click="no">
                                <div class="dot" :style="'background:' + state.color" data-click="no"></div>
                                <span data-click="no">{{ state.state }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dates">
                    <div class="update" data-click="no">
                        {{ $t('offer.row_updated') }}
                        <b data-click="no">{{ data.offer_aktualizacia }}</b>
                    </div>
                    <div class="create" data-click="no">
                        {{ $t('offer.row_created') }}
                        <b data-click="no">{{ data.offer_vytvorenie }}</b>
                    </div>
                </div>
            </div>
            <div class="right_side">
                <div class="opens" data-click="no" flex>
                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.33598 0.955476C3.30163 0.827376 3.21781 0.718167 3.10294 0.651873C2.98808 0.585579 2.85158 0.56763 2.72348 0.601976C2.59538 0.636321 2.48617 0.720147 2.41988 0.835013C2.35358 0.949879 2.33563 1.08638 2.36998 1.21448L2.49948 1.69748C2.53383 1.82558 2.61765 1.93478 2.73252 2.00108C2.84738 2.06737 2.98388 2.08532 3.11198 2.05098C3.24008 2.01663 3.34929 1.9328 3.41558 1.81794C3.48188 1.70307 3.49983 1.56658 3.46548 1.43848L3.33548 0.955476H3.33598ZM1.21448 2.36998C1.15094 2.35265 1.08461 2.34806 1.01929 2.35645C0.953966 2.36484 0.890946 2.38605 0.833846 2.41886C0.776746 2.45167 0.726691 2.49545 0.686556 2.54766C0.646421 2.59987 0.616996 2.6595 0.599972 2.72312C0.582948 2.78674 0.578659 2.8531 0.587353 2.91838C0.596046 2.98366 0.617551 3.04658 0.650631 3.10352C0.683711 3.16047 0.727715 3.21032 0.780116 3.25021C0.832517 3.2901 0.892282 3.31925 0.95598 3.33598L1.43898 3.46548C1.56685 3.49905 1.70281 3.48063 1.81713 3.41422C1.93144 3.34781 2.01481 3.23884 2.04898 3.11112C2.08316 2.98341 2.06536 2.84737 1.99949 2.73274C1.93362 2.61812 1.82503 2.53425 1.69748 2.49948L1.21448 2.36948V2.36998ZM5.62148 2.08548C5.6679 2.03902 5.70472 1.98388 5.72983 1.92319C5.75494 1.86251 5.76785 1.79747 5.76783 1.7318C5.76781 1.66612 5.75485 1.6011 5.7297 1.54043C5.70454 1.47977 5.66769 1.42465 5.62123 1.37823C5.57478 1.3318 5.51963 1.29499 5.45895 1.26987C5.39826 1.24476 5.33323 1.23185 5.26755 1.23187C5.20188 1.2319 5.13685 1.24486 5.07619 1.27001C5.01552 1.29516 4.9604 1.33202 4.91398 1.37848L4.56048 1.73198C4.51402 1.77843 4.47717 1.83358 4.45203 1.89428C4.42689 1.95497 4.41395 2.02003 4.41395 2.08573C4.41395 2.15142 4.42689 2.21648 4.45203 2.27717C4.47717 2.33787 4.51402 2.39302 4.56048 2.43948C4.60694 2.48593 4.66209 2.52278 4.72278 2.54792C4.78348 2.57306 4.84853 2.586 4.91423 2.586C4.97993 2.586 5.04498 2.57306 5.10568 2.54792C5.16637 2.52278 5.22153 2.48593 5.26798 2.43948L5.62148 2.08548ZM2.08598 5.62148L2.43948 5.26798C2.53337 5.17422 2.58616 5.04701 2.58626 4.91433C2.58635 4.78165 2.53373 4.65436 2.43998 4.56048C2.34623 4.46659 2.21902 4.41379 2.08633 4.4137C1.95365 4.4136 1.82637 4.46622 1.73248 4.55998L1.37848 4.91348C1.28466 5.0073 1.23195 5.13454 1.23195 5.26723C1.23195 5.39991 1.28466 5.52715 1.37848 5.62098C1.4723 5.7148 1.59955 5.7675 1.73223 5.7675C1.86491 5.7675 1.99216 5.7148 2.08598 5.62098V5.62148ZM3.68598 3.03598C3.59512 2.9996 3.49558 2.9907 3.3997 3.01037C3.30382 3.03004 3.21583 3.07741 3.14662 3.14662C3.07741 3.21582 3.03004 3.30382 3.01037 3.3997C2.99071 3.49557 2.99961 3.59511 3.03598 3.68598L5.03598 8.68598C5.07181 8.77546 5.13275 8.85269 5.21146 8.90834C5.29016 8.964 5.38328 8.99572 5.4796 8.99968C5.57591 9.00365 5.67132 8.97968 5.75433 8.93068C5.83734 8.88167 5.90442 8.80972 5.94748 8.72348L6.63748 7.34398L8.14648 8.85398C8.2403 8.94773 8.36752 9.00037 8.50016 9.00033C8.63279 9.00028 8.75998 8.94755 8.85373 8.85373C8.94748 8.75991 9.00013 8.63268 9.00008 8.50005C9.00003 8.36741 8.9473 8.24023 8.85348 8.14648L7.34398 6.63648L8.72398 5.94698C8.81006 5.90381 8.88184 5.8367 8.9307 5.75372C8.97956 5.67073 9.00341 5.57541 8.9994 5.47919C8.99539 5.38298 8.96367 5.28997 8.90807 5.21135C8.85248 5.13272 8.77535 5.07183 8.68598 5.03598L3.68598 3.03598Z"
                            fill="#9CA3AF" />
                    </svg>
                    {{ data.offer.opens }}{{ $t('offer.row_opened') }}
                    <br />
                    <span v-show="data.offer.opens > 0" class="reset" @click="reset_offer_opens"
                        data-click="no">{{ $t('offer.row_reset') }}</span>
                </div>
                <div class="status vue_show_tooltip">
                    <span v-show="data.offer.isFormConfirmed == 1" class="green" data-click="no"
                        @click="isFormConfirmed">
                        <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"
                            data-click="no">
                            <path d="M1.5 4.5L3.5 6.5L8.5 1.5" stroke="#2ED8B6" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <span class="rollout" data-click="no"> {{ $t('offer.row_accepted') }} </span>
                    </span>
                    <span v-show="data.offer.isFormConfirmed == 0" class="red" data-click="no" @click="isFormConfirmed">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"
                            data-click="no">
                            <path d="M1 7L7 1M1 1L7 7" stroke="#F93C34" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <span class="rollout" data-click="no"> {{ $t('offer.row_rejected') }} </span>
                    </span>
                    <tool-tip class="vue_tooltip hide" side="l" :text="data.offer.isFormConfirmed == 1
                        ? $t('offer.row_status_prefix') + ' ' +
                        formTime +
                        ' ' + $t('offer.row_status_accepted')
                        : $t('offer.row_status_prefix') + ' ' +
                        formTime +
                        ' ' + $t('offer.row_status_rejected')
                        " />
                </div>
                <div class="vue_show_tooltip price" data-click="no">
                    {{ setPrice(formatedPrice) }}
                    <tool-tip v-show="formatedPrice.length >= getLengthOfShowenPrice" class="vue_tooltip hide" side="r"
                        :text="formatedPrice" />
                    
                </div>
            </div>
        </div>
        <div class="line"></div>
        <!--line-->
        <!--bottom-->
        <offer-row-buttons :data="data" :user="user" :sendEmail="sendEmail" @changeSendStatus="changeSendStatus($event)"
            @deleteOffer="deleteOffer($event)" @de_activeOffer="de_activeOffer($event)" />
    </div>
</template>
<script>
import OfferRowButtons from "./OfferRowButtons.vue";
import ToolTip from "../../vue_components/ToolTip.vue";
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
export default {
    components: { OfferRowButtons, ToolTip },
    props: ["data", "user", "is_paid", "sendEmail"],
    data() {
        return {
            show_states: false,
            current_state: {},
        };
    },
    created() {
        this.current_state = this.data.currentState;
    },
    methods: {
        openKlient(id) {
            if(this.data.offer.is_paid_active){
                return;
            }
            this.$emit("openKlientModal", id);
        },
        updateState(state) {
            if(this.data.offer.is_paid_active){
                return;
            }
            this.current_state = state;
            axios
                .patch("/api/offers/state/"+this.data.offer.uuid, {
                    state: this.current_state.id,
                })
                .then((response) => {
                    this.$emit("stateOffer", {
                        state: this.current_state.id,
                        offer_uuid: this.data.offer.uuid,
                    });
                    this.message(this.$t('offer.row_status_changed'));
                })
                .catch(error => {
                    console.error('Error updating state:', error);
                });
        },
        editOffer(event) {
            if(this.data.offer.is_paid_active){
                return;
            }
            let clickedElement = event.target;
            let isInsideRestrictedDiv = false;
            while (clickedElement) {
                if (clickedElement.id === "email_files") {
                    isInsideRestrictedDiv = true;
                    break;
                }
                if (clickedElement.id === "delete_offer") {
                    isInsideRestrictedDiv = true;
                    break;
                }
                if (
                    clickedElement.id === "history_node_modal_button" ||
                    clickedElement.id === "history_node_modal"
                ) {
                    isInsideRestrictedDiv = true;
                    break;
                }
                clickedElement = clickedElement.parentElement;
            }

            if (
                !isInsideRestrictedDiv &&
                event.target.getAttribute("data-click") !== "no"
            ) {
                sessionStorage.removeItem("edit_polozka");
                window.location.href =
                    "/admin/offers/" + this.data.offer.uuid + "/edit";
            }
        },
        isFormConfirmed() {
            if(this.data.offer.is_paid_active){
                return;
            }
            swal
                .fire({
                    title: this.$t('offer.row_reset_title'),
                    text: this.$t('offer.row_reset_text'),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    cancelButtonText: "Nie",
                    confirmButtonText: this.$t('offer.row_reset_btn'),
                })
                .then((result) => {
                    if (result.value) {
                        axios
                            .patch(
                                "/api/offers/isFormConfirmed/"+this.data.offer.uuid,{}
                            )
                            .then((response) => {
                                this.message(this.$t('offer.row_status_removed'));
                                this.$emit(
                                    "isFormConfirmed",
                                    this.data.offer.uuid
                                );
                            });
                    }
                });
        },
        changeSendStatus(uuid) {
            if(this.data.offer.is_paid_active){
                return;
            }
            axios.patch("/api/offer/send/" + uuid).then((response) => {
                this.$emit("changeSendStatus", uuid);
                this.message(
                    this.data.offer.send_status == 0
                        ? this.$t('offer.row_send_unsent')
                        : this.$t('offer.row_send_sent')
                );
            });
        },
        de_activeOffer(uuid) {
            if(this.data.offer.is_paid_active){
                return;
            }
            axios.get("/api/offers/public/" + uuid).then((response) => {
                this.$emit("de_activeOffer", uuid);
                this.message(
                    this.data.offer.active == 0
                        ? "Ponuka bola nastavená ako aktívna."
                        : "Ponuka bola nastavená ako neaktívna."
                );
            });
        },
        reset_offer_opens() {
            if(this.data.offer.is_paid_active){
                return;
            }
            axios
                .patch("/api/offer/opens/" + this.data.offer.id)
                .then((response) => {
                    this.$emit("resetOpens", this.data.offer.id);
                    this.message("Počet otvorení bol obnovený.");
                });
        },
        deleteOffer(id) {
            if(this.data.offer.is_paid_active){
                return;
            }
            axios.delete("/api/offers/" + id).then((response) => {
                this.$emit("deleteOffer", id);
                this.message("Ponuka bola odstránena.");
            });
        },
        setPrice(price) {
            if (price.length < this.getLengthOfShowenPrice) return price;
            return price.slice(0, this.getLengthOfShowenPrice-3) + "...";
        },
        setTitle(title) {
            var len = title.length;
            if (len < 100) return title;
            return title.slice(0, 100) + "...";
        },
        message(text) {
            this.$toast.success(text, {
                position: "top-right",
                timeout: 2038,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false,
            });
        },
    },
    watch: {
        "data.currentState": function () {
            this.current_state = this.data.currentState;
        },
    },
    computed: {
        getLengthOfShowenPrice() {
            if(this.data.cena_zlava_do)
                return 14 * 2.5;
            return 14;
        },
        getCreatedName() {
            if (this.data.offer.user_created != null) {
                if (this.data.offer.user_created.meno) {
                    if (this.data.offer.user_created.priezvisko) {
                        return (
                            this.data.offer.user_created.meno +
                            " " +
                            this.data.offer.user_created.priezvisko
                        );
                    }
                }
                return this.data.offer.user_created.email;
            }
        },
        orderOfferState() {
            return this.data.states.sort((a, b) => parseInt(a.state_order) - parseInt(b.state_order))
        },
        formTime() {
            if (this.data.offer.isFormConfirmed_time)
                return this.data.offer.isFormConfirmed_time.replace(" ", " o ");
            return;
        },
        formatedPrice() {
            const formatter = new Intl.NumberFormat("sk-SK", {
                style: "currency",
                currency: "EUR",
                maximumFractionDigits: 0,
            });
            var new_price = formatter.format(this.data.offer.cena_without_dph);
            new_price = new_price.replace("€", this.data.offer.currencySymbol);

            if (this.data.cena_zlava_do) {
                new_price = new_price + " - " + formatter.format(this.data.offer.cena_do_without_dph).replace("€", this.data.offer.currencySymbol);
            }
            return new_price;
        },
    },
    mounted() {
        $(".vue_show_tooltip").hover(
            function () {
                $(this).find(".vue_tooltip").removeClass("hide");
                $(this).find(".vue_tooltip").addClass("show");
            },
            function () {
                $(this).find(".vue_tooltip").removeClass("show");
                $(this).find(".vue_tooltip").addClass("hide");
            }
        );
    },
};
</script>

<style lang="scss" scoped>
.who_create_offer_cont {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.who_create_offer {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 14px;
    height: 14px;

    margin-left: 15px;

    background: #f3f4f6;
    border-radius: 14px;
}

.who_create_offer_text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: #9ca3af;
    margin-left: 7px;
}

.vue_tooltip .hide {
    display: none;
}

.vue_tooltip .show {
    display: block;
}

.vue_show_tooltip {
    position: relative;
}

.box {
    background: white;
    border-radius: 6px;
    padding-top: 21px;
    padding-bottom: 17px;
    margin-bottom: 15px;
    cursor: pointer;
    transition: all 0.6ms;

    &:hover {
        transition: box-shadow 0.3s ease-in-out;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }

    & span.title {
        margin: 0 0px 5px 14px;
        display: flex;
        align-items: center;

        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #212541;

        .type {
            margin-right: 7px;

            & span {
                display: block;
                border-radius: 50%;
                cursor: pointer;

                width: 6px;
                height: 6px;

                &.red {
                    background: #f93c34;
                }

                &.orange {
                    background: #fbbf24;
                }

                &.green {
                    background: #34d399;
                }
            }
        }
    }

    .top {
        margin: 0 17px 33px 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media (max-width: 1200px) {
            flex-direction: column;
        }

        .left_side {
            display: flex;
            align-items: center;
            @media (max-width: 1200px) {
                width: 100%;
                justify-content: space-between;
            }
            @media (max-width: 600px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 16px;
            }

            .title_client {
                display: grid;
                width: 300px;
                min-width: 300px;
                max-width: 300px;


                a.user_provided_id {
                    margin-top: 5px;
                    margin-left: 15px;
                    color: var(--gray-400, #9ca3af);
                    font-family: Montserrat;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    text-decoration: none;
                }

                & a.client {
                    margin-left: 15px;

                    font-family: "Montserrat";
                    font-style: normal;
                    font-weight: 700;
                    font-size: 12px;
                    line-height: 15px;
                    color: #9ca3af;

                    &:hover {
                        text-decoration: underline;
                        color: #9ca3af;
                    }

                    &.text-danger {
                        color: #f93c34;
                    }
                }
            }

            .state_container {
                width: 130px;
            }

            .state {
                position: relative;
                width: max-content;
                max-width: 120px;
                height: 24px;
                box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05);
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 8px 0 0 20px;
                padding: 0 7px;

                .current_state {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    span {
                        font-family: "Montserrat";
                        font-style: normal;
                        font-weight: 600;
                        font-size: 9px;
                        line-height: 11px;
                        letter-spacing: 0.12em;
                        text-transform: uppercase;
                        color: #ffffff;
                    }

                    svg {
                        margin-left: 7px;

                        &.rotate {
                            transition: 0.5 all;
                            transform: rotate(180deg);
                        }

                        path {
                            stroke: #ffffff;
                        }
                    }
                }

                .state1 {
                    span {
                        color: #595c71;
                    }

                    svg {
                        path {
                            stroke: #595c71;
                        }
                    }
                }

                .other_states {
                    background: #ffffff;
                    border: 1px solid #f3f4f6;
                    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.05);
                    border-radius: 5px;
                    padding: 9px;
                    position: absolute;
                    z-index: 100;
                    top: 35px;
                    left: 0;

                    .one_state {
                        width: 140px;
                        padding: 9px 7px;
                        display: flex;
                        align-items: center;
                        justify-content: baseline;
                        border-radius: 4px;

                        &.active {
                            background: #f3f4f6;
                        }

                        &:hover {
                            transition: 0.5 all;
                            background: #f3f4f6;
                        }

                        .dot {
                            width: 6px;
                            height: 6px;
                            border-radius: 6px;
                            margin-right: 7px;
                        }

                        span {
                            font-family: "Montserrat";
                            font-style: normal;
                            font-weight: 600;
                            font-size: 10px;
                            line-height: 12px;
                            letter-spacing: 0.12em;
                            text-transform: uppercase;
                            color: #212541;
                        }
                    }
                }
            }

            .dates {
                margin-left: 20px;
                display: grid;
                margin-top: 8px;

                & .update,
                & .create {
                    font-family: "Montserrat";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 10px;
                    line-height: 12px;
                    color: #9ca3af;
                }
            }
        }

        .right_side {
            display: flex;
            align-items: center;
            margin-top: 8px;

            @media (max-width: 1200px) {
                margin-top: 25px;
                margin-left: 18px;
                justify-content: space-between;
                width: 95%;
            }

            .opens {
                white-space: nowrap;
                font-family: "Montserrat";
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 12px;
                color: #9ca3af;

                & span.reset {
                    text-decoration-line: underline;
                    color: #9ca3af;
                    margin-left: 16px;
                    cursor: pointer;
                }

                & svg {
                    margin-right: 5px;
                }
            }

            .status {
                margin-right: 13px;
                margin-left: 8px;
                width: 130px;
                display: flex;
                justify-content: flex-end;

                & span {
                    cursor: pointer;
                    width: 24px;
                    height: 24px;
                    border-radius: 24px;
                    display: flex;
                    align-items: center;
                    position: relative;
                    overflow: hidden;
                    justify-content: center;
                    transition: all 0.3s;

                    svg {
                        position: absolute;
                    }

                    &.green svg {
                        right: 7px;
                        top: 9px;
                    }

                    &.red svg {
                        right: 8px;
                        top: 8px;
                    }

                    &.green {
                        background: #ecfdf5;
                    }

                    &.red {
                        background: #fef2f2;
                    }

                    &:hover {
                        width: 130px;

                        .rollout {
                            opacity: 1;
                            transform: translateX(0);
                        }
                    }

                    .rollout {
                        font-family: "Montserrat";
                        font-style: normal;
                        font-weight: 500;
                        font-size: 11px;
                        line-height: 12px;
                        opacity: 0;
                        transform: translateX(-100%);
                        position: absolute;
                        left: 0;
                        width: 115px;
                        display: flex;
                        margin-right: 0.75rem;
                        transition: transform 0.3s ease-in-out;
                    }

                    &.green .rollout {
                        color: #2ed8b6;
                    }

                    &.red .rollout {
                        color: #f93c34;
                    }
                }
            }

            .price {
                max-width: 220px;
                display: flex;
                justify-content: flex-end;
                font-family: "Montserrat";
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 17px;
                color: #212541;
                margin-right: 7px;
            }
        }
    }

    .line {
        border: 1px solid #f2f2f2;
        width: 100%;
    }
}
</style>